<template lang="pug">
tr(
  :key="`${item.ID}-row`" :active="isSelected"
  :class="{'updated' : item.animation, 'app-table__row_expanded': isExpanded}"
  :style="{'background-color': candidateColor}"
  data-test="candidate-row"
).row-animation
  td
    v-checkbox(
      data-test="c-checkbox-select"
      hide-details 
      :value="isSelected"
      :key="index"
      @change="select"
      @click.native="selectWithShiftkey({event: $event, item: item, index: index})"
    ).mt-0
    div.row-labels
      label-primary(v-for="label in currentLabels" :key="label.ID" :text="label.name" :color="label.color")

  td.app-table__cell.app-table__cell_small
    .d-flex
      copy(:model="item")
      v-icon(
        :class="{'expanded': isExpanded}" 
        @click="goToEdit({expand: expand, isExpanded: isExpanded})" 
        data-test="candidate-open"
      ) mdi-chevron-right

  td(@click="goToEdit({expand: expand, isExpanded: isExpanded})" data-test="candidate-position") {{ positionInList }}

  td

  td(@click="goToEdit({expand: expand, isExpanded: isExpanded})")
    div.table-date.table-date_additional.text-center {{ item.appPlacedAtFormatted }}
    div.table-date.table-date_additional.text-center {{ item.appPaidAtFormatted }}

  td(:style="{maxWidth: '100px'}" @click="goToEdit({expand: expand, isExpanded: isExpanded})" data-test="candidate-name")
    | {{ item.fullName }}

  td(@click="goToEdit({expand: expand, isExpanded: isExpanded})")
    template(v-if="item.candidateNumber" ) 
      span(v-html="candidateNumberSplicedOnTwoElement").cdr
    candidate-label(:model="item")

  td.nowrap(data-test="candidate-bday")
    div(@click="goToEdit({expand: expand, isExpanded: isExpanded})") {{ item.candidateBirthday }}
    span.block( v-if="!loading"  v-html="telSplicedOnTwoElement" :id="`${item.ID}-tel`" @click="triggerTelClick")
  td
    accept-activator(:ID="item.ID" :model="item") 
      template(v-slot:activator="{toggle}")
        span(@click="toggle" data-test="candidate-row-accept").hover-pointer {{ cbrAccount }}
  td(@click="goToEdit({expand, isExpanded})").text-center {{ item.applicationId }}
  td(@click="$emit('click:payments', item)")
    check-boolean(:value="item.is_course_paid")
    v-menu(top offset-y max-width="400" open-on-hover content-class="templates-tooltip")
      template(v-slot:activator="{ on }")
        span(v-on="on").hover-pointer.ml-1 {{ item.paidAmount}} &euro;
      paymentsLog(:list="item.payments")
    

  td(:style="{maxWidth: '120px', minWidth: '100px'}"
      :class="{'exchanged': item.wasExchanged, 'mijn-reservation': item.isMijnReservation}"
      @click="goToEdit({expand: expand, isExpanded: isExpanded})")
    p(v-if="!item.reservedExam.location && !item.reservedExam.examDate").text-center -
    p(v-if="item.reservedExam.location").mt-0.mb-0.text-center.overflow-text  {{ item.reservedExam.location}}
    p(v-if="item.reservedExam.examDate").mb-0.mt-0.text-center.overflow-text {{ item.reservedExam.examDate}}

  td(@click="goToEdit({expand: expand, isExpanded: isExpanded})") {{ item.productName }}

  td(@click="goToEdit({expand: expand, isExpanded: isExpanded})" data-test="cbr-status") {{ item.status }}
  td 
    removeFromAccept(
      :status="item.status" 
      :ID="item.ID" 
      :newExchange="item.newExchange" 
      :newReserve="item.newReserve"
    )

  td(@click="goToEdit({expand: expand, isExpanded: isExpanded})" :style="{maxWidth: '150px'}").text-center
    template(v-if="item.lastError") 
      show-more(:text="item.lastError" :height="'30px'")
    template(v-else) -

  td.comment-td
    show-more(:text="item.appComment"  :classes="['text-ellipsis']")
  td
    LogEmailProvider(:getLogs="getSentEmails" v-slot:default="emailLogs")
      baseEmailTemplateProvider
        template(
          v-slot:default="baseEmail"
        )
          EmailTemplatesSendProvider(
            :ID="item.ID" 
            :model="item"
            :formErrors="baseEmail.formErrors"
            v-slot:default="sendProvider"
            @send="emailLogs.addToLogs"
          )
            EmailTemplates(
              :items="baseEmail.list"
              :itemsLoading="baseEmail.listLoading"
              :editedTemplate="baseEmail.editedTemplate"
              :loadData="baseEmail.loadData"
              :logs="baseEmail.logs"
              :formErrors="baseEmail.formErrors"
              :processing="baseEmail.processing"
              :maxItemsShowing="8"
              @templateSelected="baseEmail.loadTemplateData"
              @onAddCustomTemplate="baseEmail.loadCreateTemplate"
              @submit="sendProvider.sendEmail"
              @save="baseEmail.post"
              @update="baseEmail.update"
              @remove="baseEmail.remove"
            )
              <template v-slot:tooltip>
                v-menu(left offset-x max-width="400" open-on-hover content-class="templates-tooltip" @input="emailLogs.setTemplateTooltipShowing")
                  template(v-slot:activator="{ on }")
                      v-icon(v-on="on") mdi-email
                  templatesLog(:list="emailLogs.logs")
              </template>
              <template lang="pug">
                v-col
                  h3.email-templates__subtitle Email logs
                  templatesLog(:list="emailLogs.logs" :loading="emailLogs.logsLoading")
              </template>
                

  td.table-dates
    course-confirmed(:item="item").cell-dates
  
  td.nowrap
    div(v-for="(request, index) in item.sortedFilteredRequests" :key="index").table-reservation
      reservation-date(
        :request="request"
        :filteredRequests="item.sortedFilteredRequests"
        :index="index"
        v-if="request.examDate && index < 2"
      )
  td.note-td
    note(:value="item.notes" :ID="item.ID")
</template>

<script>
import copyMixin from "@/mixins/copy.mixin"
import candidateRowMixin from "../../core/candidate-row.mixin"

import CandidateLabel from "./CandidatesLabel.vue"
import AcceptActivator from "../CandidateAcceptActivator.vue"
import ReservationDate from "./CandidatesReservedDate.vue"
import Note from "./CandidatesNote.vue"
import Copy from "./CandidatesCopy.vue"
import EmailTemplatesProvider from "./CandidatesEmailTemplatesProvider.vue"
import EmailTemplates from "./CandidatesEmailTemplates"
import BaseEmailTemplateProvider from "./CandidatesEmailBaseProvider.vue"
import EmailTemplatesSendProvider from "./CandidatesEmailSendProvider.vue"
import LogEmailProvider from "./CandidateEmailLogProvider.vue"
import TemplatesLog from "./CandidatesETempLog.vue"
import PaymentsLog from "../payments/CandidatesPaymentLog.vue"
import RemoveFromAccept from "../CandidateItemRFA.vue"
import CourseConfirmed from "./CandidateCourseConfirmed.vue"
import CandidateArchive from "../CandidatesArchive.vue"
import CheckBoolean from "@/components/global/CheckBoolean.vue"
import { mapState } from 'vuex'

export default {
  mixins: [copyMixin, candidateRowMixin],
  props: {
    isSelected: Boolean,
    isExpanded: Boolean,
    expand: Function,
    select: Function,
    item: {
      type: Object,
      required: true
    },
    index: Number,
    pagination: Object,
    primaryPagination: Object,
    moreThanOnePageVisible: Boolean,
    activeItems: Array,
    labels: Array,
    loading: Boolean
  },

  computed: {
    ...mapState('crmCandidateColors', {
      colors: state => state.colors
    }),
    candidateColor() {
      if (this.candidateColorID) {
        return this.colors.find(color => color.id === this.candidateColorID).hex_color_code
      } else {
        return ''
      }
    },
    currentLabels() {
      if(!this.item.labels || !this.labels) return []
      return this.item.labels.map(labelID => {
        let sameLabel = this.labels.find(label => {
          if(label.ID === labelID) return label
        })
        if(sameLabel) return sameLabel
      })
    }
  },

  methods: {
    triggerTelClick() {
      let tel = document.createElement('a')
      tel.href = `tel:${this.item.candidateTel}`
      tel.click()
    }
  },

  components: {
    candidateLabel: CandidateLabel,
    acceptActivator: AcceptActivator,
    candidateArchive: CandidateArchive,
    reservationDate: ReservationDate,
    note: Note,
    copy: Copy,
    EmailTemplatesProvider: EmailTemplatesProvider,
    EmailTemplates: EmailTemplates,
    baseEmailTemplateProvider: BaseEmailTemplateProvider,
    EmailTemplatesSendProvider: EmailTemplatesSendProvider,
    LogEmailProvider: LogEmailProvider,
    templatesLog: TemplatesLog,
    paymentsLog: PaymentsLog,
    removeFromAccept: RemoveFromAccept,
    courseConfirmed: CourseConfirmed,
    CheckBoolean,

    showMore: () => import('@/components/global/showMoreTooltip.vue'),
    labelPrimary: () => import('@/components/global/LabelPrimary.vue')
  }
}
</script>

<style lang="scss" scoped>

.row-animation {
  transition: all 1s;
  height: 60px;
}

.updated {
  background-color: rgba($succes-color, .3) !important;
}

.expanded {
  transform: rotate(90deg);
  color: $primary-color !important;
}


.table-dates {
  width: 170px;
  line-height: 1.3;
  .cell-dates {
    padding: 0 15px 0 5px;
  }
}

.table-reservation {
  margin: 0 -4px;
}

.app-table td {
  font-size: 12px;
  line-height: 1.3;
}

.app-table__row_expanded {
  > td {
    border-top: 1px solid $primary-color;
    &:first-child {
      border-left: 1px solid $primary-color;
    }
    &:last-child {
      border-right: 1px solid $primary-color;
    }
  }
}

.cdr {
  margin: 0 -4px;
}

.note-td {
  max-width: 150px;
}
.comment-td {
  max-width: 80px;
}

.row-labels {
  position: absolute;
  margin-top: 5px;
}

.exchanged{
  background-color: $warning-color;
}

.mijn-reservation{
  background-color: $yellow-color;
}

.templates-tooltip::v-deep {
  padding: 0;
  background-color: #fff;
  opacity: 1;
}
</style>